import { Api } from './Api';

export function* getPricing(zipcode){
    const jsonData = yield Api.get(`/pricing?zipcode=${zipcode}`);
    return jsonData;
}